import React from "react";
import { Alert, Box, Button, Chip, Stack, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import {
  changeBatchStatus,
  getBatchesList,
  getCardsData,
} from "../../redux/features/batchSlice";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import { ro } from "date-fns/locale";
import { use } from "react";
import { useSelector } from "react-redux";

export default function StartConfirmation({
  row,
  disabled,
  dispatchData,
  start,
  open,
  setOpen,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  // const [open, setOpen] = React.useState(false);

  const { loading } = useSelector((state) => state.batch);

  const handleStartorStop = () => {
    let type;

    if (start === "Start" && row.courseBatchStatus === "Temporary Inactive") {
      type = 5;
    } else if (start === "Start" && row.courseBatchStatus === "Upcoming") {
      type = 1;
    } else if (start === "Stop") {
      type = 4;
    }
    const payload = {
      type,
      batchID: row.course_batch_id,
    };

    dispatch(changeBatchStatus(payload)).then((res) => {
      if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, { variant: "success" });
        dispatch(getBatchesList(dispatchData));
        dispatch(getCardsData());
      } else {
        enqueueSnackbar(res.payload.message, { variant: "error" });
      }
      setOpen(false);
    });
  };

  return (
    <div>
      <GlobalDialog
        title={"Action"}
        open={open}
        setOpen={setOpen}
        fullWidth
        maxWidth={"xs"}
        content={
          <>
            {row?.isReadyToStart === false && start === "Start" && (
              <Stack direction="column" spacing={1}>
                <Alert severity="info" color="info" variant="outlined">
                  {row?.messages}
                </Alert>
              </Stack>
            )}
            {row?.isReadyToStart === true &&
              start === "Start" &&
              row?.courseBatchStatus === "Upcoming" &&
              row?.batch_inactive_approval_status === 1 && (
                <Typography>
                  Are you sure you want to start the Batch?
                </Typography>
              )}
            {start === "Stop" && (
              <Typography>Are you sure you want to stop the Batch?</Typography>
            )}
            {start === "Start" &&
              row?.courseBatchStatus === "Temporary Inactive" &&
              row?.isReadyToStart === true &&
              row?.batch_inactive_approval_status === 1 && (
                <Typography>
                  Are you sure you want to restart the Batch?
                </Typography>
              )}
            {row?.batch_inactive_approval_status === 0 &&
              start === "Start" &&
              row?.isReadyToStart === true && (
                <Alert color="info" severity="info" variant="outlined">
                  CRM Approval Required to Start the Batch
                </Alert>
              )}
          </>
        }
        actionButton={
          <>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              color="secondary"
              disabled={
                (row?.isReadyToStart === false && start === "Start") ||
                (row?.batch_inactive_approval_status === 0 && start === "Start")
              }
              onClick={() => handleStartorStop()}
            >
              {loading ? "Loading..." : "Confirm"}
            </Button>
          </>
        }
      />
    </div>
  );
}
